import { render, staticRenderFns } from "./TableRating.vue?vue&type=template&id=463879b6"
import script from "./TableRating.vue?vue&type=script&lang=js"
export * from "./TableRating.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports